import { HabitSchedule } from '@griply/types';
import isEqual from 'lodash/isEqual';

// Which days the habit lands on — not when it runs on them, nor how long the period lasts.
export const hasScheduleDefinitionChanged = (
  initial: HabitSchedule,
  updated: HabitSchedule,
): boolean =>
  initial.rrule.format !== updated.rrule.format ||
  !isEqual(initial.frequency, updated.frequency) ||
  (initial.completionTarget?.count ?? null) !==
    (updated.completionTarget?.count ?? null);
